import { render, staticRenderFns } from "./SlideCarousels.vue?vue&type=template&id=2f3a325a&scoped=true&"
import script from "./SlideCarousels.vue?vue&type=script&lang=js&"
export * from "./SlideCarousels.vue?vue&type=script&lang=js&"
import style0 from "./SlideCarousels.vue?vue&type=style&index=0&id=2f3a325a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a325a",
  null
  
)

export default component.exports